import { tns } from "tiny-slider/src/tiny-slider";

document.addEventListener("DOMContentLoaded", function () {
    const timelineStoria = document.querySelector(".timelineStoria");

    if (timelineStoria) {
        tns({
            container: ".timelineStoria",
            items: 4,
            loop: false,
            swipeAngle: false,
            edgePadding: 50,
            speed: 300,
            nav: false,
            autoplay: true,
            autoplayButtonOutput: false,
            controls: true,
            controlsPosition: "top",
            controlsText: [
                '<span class="rounded-full h-14 w-14 flex items-center justify-center border border-white border-opacity-30 bg-techne-blu-scuro-variante focus:outline-none focus:ring absolute left-2 sm:left-12 z-10 -mt-1"><i class="fas fa-caret-left text-2xl"></i></span>',
                '<span class="rounded-full h-14 w-14 flex items-center justify-center border border-white border-opacity-30 bg-techne-blu-scuro-variante focus:outline-none focus:ring absolute right-2 sm:right-12 z-10 -mt-1"><i class="fas fa-caret-right text-2xl"></i></span>',
            ],
            responsive: {
                320: {
                    items: 1,
                },
                640: {
                    items: 2,
                },
                1280: {
                    items: 3,
                },
                2200: {
                    items: 4,
                },
            },
        });
    }

    const previewNews = document.querySelector(".previewNews");
    if (previewNews) {
        tns({
            container: ".previewNews",
            items: 4,
            loop: false,
            swipeAngle: false,
            edgePadding: 50,
            speed: 300,
            nav: false,
            autoplay: false,
            autoplayButtonOutput: false,
            controls: true,
            controlsPosition: "top",
            controlsText: [
                '<span class="rounded-full h-14 w-14 flex items-center justify-center border border-white border-opacity-30 focus:outline-none focus:ring absolute left-2 sm:left-12 z-10 -mt-1"><i class="fas fa-caret-left text-2xl"></i></span>',
                '<span class="rounded-full h-14 w-14 flex items-center justify-center border border-white border-opacity-30 focus:outline-none focus:ring absolute right-2 sm:right-12 z-10 -mt-1"><i class="fas fa-caret-right text-2xl"></i></span>',
            ],
            responsive: {
                320: {
                    items: 1,
                },
                640: {
                    items: 2,
                },
                1280: {
                    items: 3,
                },
                2200: {
                    items: 3,
                },
            },
        });
    }
});
